import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { DataService } from '../services/data.service';
import { UtilService } from '../services/util.service';
import { AuthorityPoint } from '../models/authoritypoint';
import { TrackAuthority } from '../models/trackauthority';
import { LineItem } from '../models/lineitem';
import { EntryLocation } from '../models/entrylocation';
import { Location } from '../models/location';
import { Comment } from '../models/comment';
import { LineItemModel } from '../models/lineitemmodel';
import { Status } from '../models/status.enum';
import { Direction } from '../models/direction.enum';
import { AuthorityPointGroup } from '../models/authoritypointgroup';
import { CommentType } from '../models/commenttype.enum';
import { PointType } from '../models/pointtype.enum';
import { HttpResponse } from '../models/http';
import { User, RolesAllowed } from '@csx/security';
import { EmployeeInCharge } from '../models/employeeInCharge';
import { ChangeRequestService } from '../services/changerequest.service';
import { ProxyUser } from '../models/proxyuser';
import { environment } from '../../environments/environment';

@Component({
  selector: 'authority-dialog',
  templateUrl: './createauthority.component.html',
  styleUrls: ['./createauthority.component.scss']
})
@RolesAllowed(['client.atam.eic'])
export class CreateAuthorityComponent implements OnChanges {
  @Output() onCloseDialog = new EventEmitter();
  @Input() display: boolean = false;
  @Input() authority: TrackAuthority;
  @ViewChild('prefixMilepostInput') prefixMilepostInput: ElementRef;

  dispatcherComment: Comment = null;

  blockDialog: boolean = false;
  hasOutOfRangeViolation: boolean = false;
  timerCheck: boolean = false;

  combinedPrefixMilepost: string;
  combinedPrefixMilepostValidationMessage: string;
  timerValidationMessage: string;
  expirationDate: Date;
  expirationHour: number;
  expirationMins: number;
  expirationTimeValidationMessage: string;
  minDate: Date = new Date();
  invalidDate: Date;
  range: string;
  comment: string;
  commentValidationError: string = null;

  lineItemModelList: LineItemModel[];
  authorityPointGroupList: AuthorityPointGroup[];
  selectedLineItem: LineItemModel;

  prefix: string;
  milepost: number;
  private requestTimer: any;

  isRequestNewSection: Boolean = false;
  isAuthoritiesAvailable: Boolean = false;
  isDetailAuthority: Boolean = false;
  authorities: Array<TrackAuthority> = [];
  authorityData: TrackAuthority;
  Direction = Direction;
  shouldHideAdditionalLimits: boolean = environment.appConfig.featureFlags.hideAdditionalLimits;

  constructor(private dataService: DataService, private user: User, private changeRequestService: ChangeRequestService, private proxy: ProxyUser) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.minDate = new Date();
    if (changes.display && changes.display.currentValue) {
      this.hasOutOfRangeViolation = false;
      this.combinedPrefixMilepost = null;
      this.combinedPrefixMilepostValidationMessage = null;
      this.timerValidationMessage = null;
      this.commentValidationError = null;
      this.expirationTimeValidationMessage = null;

      this.expirationDate = new Date();
      this.expirationHour = this.expirationDate.getHours();
      this.expirationMins = this.expirationDate.getMinutes();

      this.range = '5';
      this.comment = null;
      this.lineItemModelList = new Array<LineItemModel>();
      this.authorityPointGroupList = new Array<AuthorityPointGroup>();
      this.selectedLineItem = null;
      this.prefix = null;
      this.milepost = 0;
      this.dispatcherComment = null;
      if (changes.authority != null) {
        this.prepareFromAuthority();
      } else {
        this.addLineItem();
      }
    }
  }

  focusEntryLocation(): void {
    if (this.authority === null || this.authority === undefined) {
      this.prefixMilepostInput.nativeElement.focus();
    }
  }

  requestValidateAndGetAuthorityPointGroup(event): void {
    clearTimeout(this.requestTimer);
    this.requestTimer = setTimeout(() => {
      this.prefixMilepostInput.nativeElement.focus();
      this.prefixMilepostInput.nativeElement.blur();
    }, 2000);
  }

  validateAndGetAuthorityPointGroup(event): void {
    if (this.combinedPrefixMilepost !== undefined && this.combinedPrefixMilepost !== null) {
      this.combinedPrefixMilepost = this.combinedPrefixMilepost.toUpperCase();
    }
    this.combinedPrefixMilepostValidationMessage = null;
    this.combinedPrefixMilepostValidationMessage = LineItemModel.validateCombinedPrefixMilepostPattern(this.combinedPrefixMilepost);
    if (this.combinedPrefixMilepostValidationMessage === null) {
      let arr: string[] = this.combinedPrefixMilepost.split(' ');
      this.prefix = arr[0];
      this.milepost = parseFloat(arr[1]);
      this.authorities = [];
      this.getAuthorityPoints();
    }
  }

  onCancel(): void {
    let pageDirty = false;
    this.invalidDate = undefined;
    this.timerCheck = false;
    this.timerValidationMessage = null;

    if (this.lineItemModelList) {
      this.lineItemModelList.forEach(child => {
        pageDirty = pageDirty || child.isDirty();
      });
    }

    if (!pageDirty || (pageDirty && confirm('Are you sure you want to quit?'))) {
      this.resetFlags();
      this.onCloseDialog.emit({ value: 'false' });
    }
  }

  getLineNumberIdentifier(charCode: number): string {
    return String.fromCharCode(charCode);
  }

  addLineItem(): void {
    let lineLitemModel: LineItemModel = new LineItemModel();
    this.lineItemModelList.push(lineLitemModel);
    this.selectedLineItem = lineLitemModel;
  }

  deleteLineItem(lineItemModel: LineItemModel): void {
    this.lineItemModelList = this.lineItemModelList.filter(item => item != lineItemModel);
    this.selectedLineItem = this.lineItemModelList[this.lineItemModelList.length - 1];
  }

  updateComments(event) {
    this.comment = event.srcElement.value;
  }

  checkHour() {
    if (this.expirationHour === null) {
      this.expirationHour = new Date().getHours();
    }
  }

  checkMinutes() {
    if (this.expirationMins === null) {
      this.expirationMins = new Date().getMinutes();
    }
  }

  onSubmit(): void {
    if (this.isRequestNewSection) {
      let isValid: boolean = this.validateRequest();
      isValid = this.validateComments() && isValid;
      if (this.combinedPrefixMilepost === null || this.combinedPrefixMilepostValidationMessage != null) {
        this.combinedPrefixMilepostValidationMessage = 'Enter a valid value';
        isValid = false;
      }
      if (isValid) {
        let date: Date = this.expirationDate;
        date.setHours(this.expirationHour);
        date.setMinutes(this.expirationMins);
        const estDate = UtilService.localToEST(date);

        let lineItemList: LineItem[] = new Array<LineItem>();
        for (let lineItemModel of this.lineItemModelList) {
          let lineItem: LineItem = {
            fromPoint: AuthorityPoint.clone(lineItemModel.selectedTrackFrom),
            toPoint: AuthorityPoint.clone(lineItemModel.selectedTrackTo),
            direction: lineItemModel.selectedDirection,
            lineNumber: this.lineItemModelList.indexOf(lineItemModel) + ''
          } as LineItem;
          // TODO json is passing array ([] with index) instead of List.
          // This is not a showstopper will figure it out later
          lineItem.fromPoint.location.subdivision && (lineItem.fromPoint.location.subdivision.directions = null);
          lineItem.toPoint.location.subdivision && (lineItem.toPoint.location.subdivision.directions = null);

          lineItemList.push(lineItem);
        }

        this.comment = this.replaceSmartPuncuation(this.comment);

        let comment: Comment = {
          type: CommentType.PUBLIC,
          racf: this.user.racf,
          text: this.comment,
          timestamp: estDate
        } as Comment;
        let employeeInCharge: EmployeeInCharge = {
          eicUserId: this.proxy.racf || this.user.racf,
          entryMilepostPrefix: this.prefix,
          entryMilepostId: this.milepost.toString(),
          primary: true
        } as EmployeeInCharge;
        let authority: TrackAuthority = {
          range: parseInt(this.range),
          lineItems: lineItemList,
          expiration: estDate,
          status: Status.AUTHORITY_REQUESTED,
          comments: [comment],
          employeeInCharges: [employeeInCharge]
        } as TrackAuthority;

        this.setBlock(true);

        this.dataService
          .postNewAuthority(authority)
          .then(
            success => {
              this.onCloseDialog.emit({ value: 'false' });
              this.setBlock(false);
              this.resetFlags();
            },
            (error: HttpResponse) => {
              if (error.statusCode === 409) this.onCloseDialog.emit({ value: 'false' });
              this.setBlock(false);
            }
          )
          .catch(response => this.setBlock(false));
      }
    } else {
      this.returnCombinedPrefixMilepost();
      const changeRequest = {
        type: 'SHARE',
        comment: this.comment,
        sharingChangeModel: {
          secondaryEICRacf: this.proxy.racf || this.user.racf,
          entryMilepostPrefix: this.prefix,
          entryMilepostId: this.milepost
        }
      };
      this.sendShareApi(changeRequest);
    }
  }

  replaceSmartPuncuation(value: string): string {
    return value
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/[\u2026]/g, '...')
      .replace(/[\u00BF]/g, '?');
  }

  setBlock(visible: boolean): void {
    this.blockDialog = visible;
  }

  setOutOfRangeViolation(violation: boolean): void {
    this.hasOutOfRangeViolation = violation;
  }

  validateComments(): boolean {
    if (this.comment === undefined || this.comment === null || this.comment === '') {
      this.commentValidationError = 'Required';
      return false;
    } else {
      this.commentValidationError = null;
      return true;
    }
  }

  validateCommentsForSpecialCharacters(): void {
    if (this.comment !== undefined && this.comment !== null) {
      this.comment = this.replaceSmartPuncuation(this.comment);
      const regex = /[<>&"']/g;
      if (regex.test(this.comment)) {
        this.commentValidationError = 'Special characters like <, >, &, " and \' are not allowed';
        this.comment = this.comment.replace(regex, '');
      } else {
        this.commentValidationError = null;
      }
    }
  }

  private prepareFromAuthority(): void {
    this.isRequestNewSection = true;
    this.dispatcherComment = this.authority.comments.find(
      comment => comment.type.toString() === CommentType[CommentType.DISPATCHER].toString()
    );

    let entryLocation: Location = this.authority.entryLocation;
    this.combinedPrefixMilepost = entryLocation.prefix + ' ' + entryLocation.milepost;
    this.expirationDate = new Date(this.authority.expiration);
    this.expirationHour = this.authority.expiration.getHours();
    this.expirationMins = this.authority.expiration.getMinutes();
    this.range = entryLocation.range === undefined || entryLocation.range === null ? '5' : entryLocation.range + '';
    this.prefix = entryLocation.prefix;
    this.milepost = parseFloat(entryLocation.milepost);
    this.comment = this.getLatestPublicComment();
    this.setBlock(true);
    this.dataService
      .getAuthorityPointsByPrefixMilepostRange(this.prefix, this.milepost, this.range)
      .then(response => {
        this.authorityPointGroupList = response;
        this.dataService
          .getAuthorityListByMilepostRange(this.milepost, this.range, this.prefix)
          .subscribe((availableAuthorities: TrackAuthority[]) => {
            this.authorities = availableAuthorities;
          });
      })
      .then(() => this.createLineItems())
      .catch(n => this.createLineItems());
  }

  private createLineItems() {
    for (let lineItem of this.authority.lineItems) {
      let lineItemModel: LineItemModel = new LineItemModel();
      lineItemModel.operatingFrom = this.findTrackAuthorityGroup(lineItem.fromPoint);
      lineItemModel.operatingTo = this.findTrackAuthorityGroup(lineItem.toPoint);
      lineItemModel.selectedTrackFrom = this.findTrackAuthority(lineItem.fromPoint);
      lineItemModel.selectedTrackTo = this.findTrackAuthority(lineItem.toPoint);
      lineItemModel.selectedDirection = lineItem.direction;
      this.lineItemModelList.push(lineItemModel);
    }
    this.selectedLineItem = this.lineItemModelList[0];
    this.setBlock(false);
  }

  private findTrackAuthority(authorityPoint: AuthorityPoint): AuthorityPoint {
    try {
      return this.findTrackAuthorityGroup(authorityPoint).points.find(
        (authPoint: AuthorityPoint) => authorityPoint.location.track.name === authPoint.location.track.name
          && authorityPoint.location.prefix === authPoint.location.prefix &&
          authorityPoint.location.milepost === authPoint.location.milepost
      );
    } catch (e) {
      return null;
    }
  }

  private findTrackAuthorityGroup(authorityPoint: AuthorityPoint): AuthorityPointGroup {
    try {
      if (authorityPoint.type === PointType.MILEPOST) {
        let authorityPointGroup: AuthorityPointGroup = {
          type: authorityPoint.type,
          commonName: authorityPoint.displayName,
          points: [authorityPoint]
        } as AuthorityPointGroup;
        this.authorityPointGroupList.push(authorityPointGroup);
      }
      return this.authorityPointGroupList.find(
        (authorityPointGroup: AuthorityPointGroup) =>
          authorityPointGroup.commonName === authorityPoint.displayName && authorityPointGroup.type === authorityPoint.type
      );
    } catch (e) {
      return null;
    }
  }

  private getLatestPublicComment(): string {
    let returnValue: Comment = null;
    this.authority.comments.forEach((comment: Comment) => {
      if (comment.type.toString() === CommentType[CommentType.PUBLIC].toString()) {
        if (returnValue === null || returnValue.timestamp > comment.timestamp) {
          returnValue = comment;
        }
      }
    });
    if (returnValue !== null) {
      return returnValue.text;
    } else {
      return '';
    }
  }

  validateTime(): boolean {
    if (this.expirationDate != undefined) {
      if (this.expirationHour > 23 || this.expirationHour < 0 || this.expirationMins < 0 || this.expirationMins > 59) {
        this.timerValidationMessage = 'Until Date & Time is not valid';
        return false;
      }
      let date: Date = new Date(this.expirationDate);
      date.setHours(this.expirationHour);
      date.setMinutes(this.expirationMins);
      date.setSeconds(0);
      date.setMilliseconds(0);

      let currentDate = new Date();
      currentDate.setSeconds(0);
      currentDate.setMilliseconds(0);

      if ((this.minDate.getDate() == date.getDate() && this.minDate.getHours() == date.getHours() && this.minDate.getMinutes() == date.getMinutes()) && this.timerCheck) {
        this.timerValidationMessage = 'Until Date & Time is not valid';
        return false;
      }

      if (!(this.minDate.getDate() == date.getDate() && this.minDate.getHours() == date.getHours() && this.minDate.getMinutes() == date.getMinutes()) && date < currentDate) {
        this.timerValidationMessage = 'Until Date & Time is not valid';
        return false;
      }
      else if (date > currentDate) {
        this.timerValidationMessage = null;
      }


    }
    return true;
  }

  private validateRequest(): boolean {
    let isValid: boolean = true;

    let date: Date = new Date(this.expirationDate);
    date.setHours(this.expirationHour);
    date.setMinutes(this.expirationMins);

    this.lineItemModelList.forEach(child => {
      isValid = child.isValid() && isValid;
    });

    if (date <= new Date() || this.expirationHour < 0 || this.expirationHour > 23
      || this.expirationMins < 0 || this.expirationMins > 59) {
      this.invalidDate = date;
      this.timerValidationMessage = 'Until Date & Time is not valid';
      this.timerCheck = true;
      isValid = false;
    }

    return isValid;
  }

  private getAuthorityPoints(): void {
    this.setBlock(true);
    this.isRequestNewSection = false;
    this.isAuthoritiesAvailable = false;
    this.isDetailAuthority = false;
    this.dataService.getAuthorityListByMilepostRange(this.milepost, this.range, this.prefix).subscribe(
      (availableAuthorities: TrackAuthority[]) => {
        this.authorities = availableAuthorities;
        this.setBlock(false);
        if (this.authorities.length > 0) {
          this.showAvailableAuthorities();
        } else {
          this.showRequestNewBox();
        }
      },
      error => {
        this.setBlock(false);
      }
    );
  }

  private format_two_digits(n: number): string {
    var num = n < 10 ? '0' + n : n;
    return num.toString();
  }

  private returnCombinedPrefixMilepost() {
    let arr: string[] = this.combinedPrefixMilepost.split(' ');
    this.prefix = arr[0];
    this.milepost = parseFloat(arr[1]);
  }

  private sendShareApi(changeRequest) {
    this.setBlock(true);
    this.changeRequestService
      .postChangeRequest(changeRequest, this.authorityData)
      .then(data => {
        this.resetFlags();
        this.setBlock(false);
        this.onCloseDialog.emit({ value: 'false' });
      })
      .catch((err: Error) => {
        this.setBlock(false);
      });
  }

  showRequestNewBox(): void {
    this.setBlock(true);
    this.dataService
      .getAuthorityPointsByPrefixMilepostRange(this.prefix, this.milepost, this.range)
      .then(response => {
        this.authorityPointGroupList = new Array<AuthorityPointGroup>();
        this.authorityPointGroupList = response;
        this.setBlock(false);
        this.isRequestNewSection = true;
        this.isAuthoritiesAvailable = false;
      })
      .catch(response => {
        this.authorityPointGroupList = new Array<AuthorityPointGroup>();
        this.setBlock(false);
        this.isRequestNewSection = true;
        this.isAuthoritiesAvailable = false;
      });
  }

  showAvailableAuthorities(): void {
    this.isRequestNewSection = false;
    this.isAuthoritiesAvailable = true;
    this.isDetailAuthority = false;
  }

  showDetailAuthority(authority: TrackAuthority): void {
    this.isRequestNewSection = false;
    this.isAuthoritiesAvailable = false;
    this.isDetailAuthority = true;
    this.authorityData = authority;
  }

  private resetFlags(): void {
    this.hasOutOfRangeViolation = false;
    this.isRequestNewSection = false;
    this.isAuthoritiesAvailable = false;
    this.isDetailAuthority = false;
    this.authorities = [];
  }
}
